export const GeoFenceType = {
    Circle: 1
}